import Person from 'assets/referral/Person.png';
import TopLeft from 'assets/referral/TopLeft.png';
import BottomRight from 'assets/referral/BottomRight.png';
import MobileRight from 'assets/referral/MobileRight.png';
import MobileLeft from 'assets/referral/MobileLeft.png';

export const ReferralBanner = () => {
    return (
        <div className={"flex py-10 px-8 bg-primary-100 rounded-lg max-lg:flex-col max-lg:p-6"}>
            <div className={"flex flex-col gap-6 w-1/2 max-lg:w-full max-lg:gap-2 z-10"}>
                <h4 className={"font-bold text-2xl text-white max-lg:text-xl"}>کسب درآمد بدون سرمایه با دعوت دوستان</h4>
                <p className={"font-normal text-base text-white max-lg:text-xs"}>کد دعوت و یا لینک زیر را برای دوستان خود ارسال کنید و با تایید هویت تعداد هر چه بیشتر دوستانتان، به ازای هر معامله ی زیر مجموعه های شما، ۵۰ درصد از کارمزد معامله را به عنوان پاداش دریافت کنید.</p>
            </div>
            <div className={"flex items-center justify-center relative w-1/2 max-lg:w-full max-lg:h-36"}>
                <img src={BottomRight} alt={"BottomRight"} className={"absolute bottom-[-40px] right-0 max-lg:hidden"} />
                <img src={MobileRight} alt={"MobileRight"} className={"absolute bottom-[-24px] right-[-24px] lg:hidden"} />
                <img src={Person} alt={"Person"} className={"absolute z-10 max-lg:bottom-[-24px]"} />
                <img src={MobileLeft} alt={"MobileLeft"} className={"absolute bottom-[-24px] left-[-24px] lg:hidden"} />
                <img src={TopLeft} alt={"TopLeft"} className={"absolute top-[-40px] left-[-32px] max-lg:hidden"} />
            </div>
        </div>
    )
}